import { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePermissions } from '../hooks/usePermissions';
import { useAuth } from '../context/AuthContext';
import OrderForm from '../components/orders/OrderForm';
import OrdersTable from '../components/orders/OrdersTable';
import UpgradeModal from '../components/common/UpgradeModal';

export default function OrdersPage() {
    const { hasFeature } = usePermissions();
    const { userProfile } = useAuth();
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);

    const canUseOrders = hasFeature('orders');
    const currentPlan = userProfile?.plan || 'basico';

    if (!canUseOrders) {
        return (
            <>
                <div>
                    <div className="d-flex justify-content-between align-items-center mb-4">
                        <div>
                            <h1 className="h3 mb-1">Pedidos</h1>
                            <p className="text-muted mb-0">Gerencie pedidos de clientes com múltiplos produtos</p>
                        </div>
                    </div>

                    {/* Bloqueio de recurso */}
                    <div className="card shadow-sm border-warning">
                        <div className="card-body text-center py-5">
                            <div className="mb-4" style={{ fontSize: '4rem' }}>
                                🔒
                            </div>
                            <h3 className="mb-3">Recurso Premium</h3>
                            <p className="text-muted mb-4">
                                A gestão de pedidos está disponível nos planos <strong>Profissional</strong> e <strong>Premium</strong>.
                            </p>

                            <div className="alert alert-info mb-4 mx-auto" style={{ maxWidth: '600px' }}>
                                <h6 className="mb-2">O que você ganha com pedidos:</h6>
                                <ul className="list-unstyled text-start mb-0">
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                        Crie pedidos com múltiplos produtos
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                        Acompanhe status de entregas
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                        Compartilhe links com clientes
                                    </li>
                                    <li className="mb-2">
                                        <i className="bi bi-check-circle-fill text-success me-2"></i>
                                        Controle completo das vendas
                                    </li>
                                </ul>
                            </div>

                            <div className="d-flex gap-3 justify-content-center">
                                <button
                                    className="btn btn-primary btn-lg"
                                    onClick={() => setShowUpgradeModal(true)}
                                >
                                    Ver Planos
                                </button>
                                <Link to="/dashboard" className="btn btn-outline-secondary btn-lg">
                                    Voltar ao Dashboard
                                </Link>
                            </div>

                            <p className="text-muted small mt-4 mb-0">
                                Você está no plano <strong>{currentPlan === 'basico' ? 'Básico (Gratuito)' : currentPlan}</strong>
                            </p>
                        </div>
                    </div>
                </div>

                <UpgradeModal
                    show={showUpgradeModal}
                    onClose={() => setShowUpgradeModal(false)}
                    feature="orders"
                />
            </>
        );
    }

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
                <div>
                    <h1 className="h3 mb-1">Pedidos</h1>
                    <p className="text-muted mb-0">Gerencie pedidos de clientes com múltiplos produtos</p>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-5 mb-4">
                    <OrderForm />
                </div>
                <div className="col-lg-7">
                    <OrdersTable />
                </div>
            </div>
        </div>
    );
}
